jQuery(document).ready(function($) {
    if ($('body').is('.logged-in')) return;

    // Bootstrap modal instances
    const modals = {
        registration: $('#modal-registration').length ? new bootstrap.Modal('#modal-registration') : null,
        information: $('#modal-information').length ? new bootstrap.Modal('#modal-information') : null,
        informationSignon: $('#modal-information-signon').length ? new bootstrap.Modal('#modal-information-signon') : null,
        resetPassword: $('#modal-reset-password-login').length ? new bootstrap.Modal('#modal-reset-password-login') : null,
        resetPasswordSuccess: $('#modal-reset-password-success').length ? new bootstrap.Modal('#modal-reset-password-success') : null
    };

    // Helper: Show error after input
    function showError(inputField, message) {
        inputField.addClass('error');
        inputField.next('.error-message').remove();
        inputField.after('<div class="error-message" style="color:red;">' + message + '</div>');
    }

    // Helper: Show error after checkbox label
    function showErrorTerms(checkboxField, message) {
        checkboxField.addClass('error');
        const label = checkboxField.closest('label');
        label.next('.error-message').remove();
        label.after('<div class="error-message" style="color:red;">' + message + '</div>');
    }

    // Helper: Show general error message in modal (for social login errors)
    function showGeneralError(modalSelector, message) {
        const modal = $(modalSelector);
        const errorContainer = modal.find('#js-message');
        
        // Clear previous errors
        modal.find('.general-error-message').remove();
        
        if (errorContainer.length) {
            errorContainer.html('<div class="general-error-message" style="color:red; padding:10px; margin-bottom:15px; background:#ffe6e6; border-radius:5px; border:1px solid #ffcccc;">' + message + '</div>');
        } else {
            // Fallback: insert before the first button in modal body
            const targetElement = modal.find('.modal-content__body .btn').first();
            if (targetElement.length) {
                targetElement.before('<div class="general-error-message" style="color:red; padding:10px; margin-bottom:15px; background:#ffe6e6; border-radius:5px; border:1px solid #ffcccc;">' + message + '</div>');
            }
        }
        
        // Auto-remove after 5 seconds
        setTimeout(function() {
            modal.find('.general-error-message').fadeOut(function() {
                $(this).remove();
            });
        }, 5000);
    }

    // Helper: Clear all error messages
    function clearAllErrors(form) { 
        form.find('.error-message, .general-error-message').remove();
        form.find('.error').removeClass('error');
    }

    function showModalLoader(modal_content) {
        $(modal_content).append('<div class="modal-content__loader"><i class="icon-load"></i></div>');
    }
    function hideModalLoader(modal_content) {
        $(modal_content).find('.modal-content__loader').remove();
    }
    function validateEmail(email) {
        return String(email).toLowerCase().match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }
    function decodeJwtResponse(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }

    // Registration form submit
    $(document).on('click', '.woocommerce-form-register__submit', function (e) {
        e.preventDefault();
        let button = $(this);
        let nonce = button.data('nonce');
        let form = button.closest('form.register');
        let modal_content = button.parents('.modal-content');

        // Clear previous errors
        form.find('.error-message').remove();
        form.find('.error').removeClass('error');

        // Get form inputs
        const emailInput = form.find('input[name=email]');
        const passwordInput = form.find('input[name=password]');
        const firstNameInput = form.find('input[name=first_name]');
        const lastNameInput = form.find('input[name=last_name]');
        const birthdayInput = form.find('input[name=birthday]');
        const termsCheckbox = form.find('input[name=terms]');

        // Get values
        let email = emailInput.val();
        let password = passwordInput.val();
        let first_name = firstNameInput.val();
        let last_name = lastNameInput.val();
        let birthday = birthdayInput.val();
        let termsAccepted = termsCheckbox.is(':checked');

        // Validate
        if (!email || !validateEmail(email)) return showError(emailInput, 'No or wrong e-mail address entered.');
        if (firstNameInput.length && !first_name) return showError(firstNameInput, 'Please enter your first name.');
        if (lastNameInput.length && !last_name) return showError(lastNameInput, 'Please enter your last name.');
        if (passwordInput.length && !password) return showError(passwordInput, 'No or wrong password entered.');
        if (!termsAccepted) return showErrorTerms(termsCheckbox, 'You must agree to the terms and conditions.');

        // AJAX
        let data = {
            action: 'woocommerce_ajax_register_user',
            first_name, last_name, birthday, password, email, nonce
        };
        // Append Turnstile token when the widget is present in the form
        let turnstileTokenReg = form.find('input[name="cf-turnstile-response"]').val();
        if (turnstileTokenReg) {
            data['cf-turnstile-response'] = turnstileTokenReg;
        }
        if (modal_content && modal_content.length) showModalLoader(modal_content);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            success: function (response) {
                if (modal_content && modal_content.length) hideModalLoader(modal_content);
                if (response.success) {
                    $('#js-message').text(response.messages.success_message);
                    if (modals.registration) modals.registration.hide();
                    if (modals.information) modals.information.show();
                    setTimeout(function () { location.reload(); }, 2200);
                } else {
                    // Show all errors
                    for (const [error, message] of Object.entries(response.messages)) {
                        if (error === 'email_error') showError(emailInput, message);
                        if (error === 'password_error') showError(passwordInput, message);
                        if (error === 'registration_error_message') showError(emailInput, message);
                    }
                }
            },
            error: function() {
                if (modal_content && modal_content.length) hideModalLoader(modal_content);
                showError(emailInput, 'An error occurred. Please try again later.');
            }
        });
    });

    // Login form submit
    $(document).on('click', '#wc_sign_in', function (e) {
        e.preventDefault();
        let button = $(this);
        let nonce = button.data('nonce');
        let modal_content = button.parents('.modal-content');
        let form = button.closest('form.login');
        let input_password = form.find('.js-password-validation');

        // Clear previous errors
        form.find('.error-message, .error_message').remove();
        form.find('.error').removeClass('error');

        const emailInput = form.find('input[name=username]');
        const passwordInput = form.find('input[name=password]');
        let email = emailInput.val();
        let password = passwordInput.val();

        if (!email || !validateEmail(email)) return showError(emailInput, 'No or wrong e-mail address entered.');
        if (!password || (input_password.length && input_password.is('.error'))) return showError(passwordInput, 'No or wrong password entered.');

        let data = {
            action: 'woocommerce_ajax_sign_in_user',
            password, email, nonce
        };
        // Append Turnstile token when the widget is present in the form
        let turnstileTokenLogin = form.find('input[name="cf-turnstile-response"]').val();
        if (turnstileTokenLogin) {
            data['cf-turnstile-response'] = turnstileTokenLogin;
        }
        if (modal_content && modal_content.length) showModalLoader(modal_content);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            success: function (response) {
                if (modal_content && modal_content.length) hideModalLoader(modal_content);
                if (response.success) {
                    $('#js-message').text(response.messages.success_message);
                    if (modals.informationSignon) modals.informationSignon.show();
                    setTimeout(function () { location.reload(); }, 3000);
                } else {
                    button.siblings('.error_message').remove();
                    button.after('<div class="error-message error_message" style="color:red;">'+ response.messages.login_error_message +'</div>');
                }
            },
            error: function() {
                if (modal_content && modal_content.length) hideModalLoader(modal_content);
                button.siblings('.error_message').remove();
                button.after('<div class="error-message error_message" style="color:red;">An error occurred. Please try again later.</div>');
            }
        });
    });

    // Password reset handler
    $(document).on('click', '#wc_reset_password', function (e) {
        e.preventDefault();
        let button = $(this);
        let nonce = button.data('nonce');
        let form = button.closest('form.lost_reset_password');
        let modal_content = button.parents('.modal-content');

        // Clear previous errors
        form.find('.error-message').remove();
        form.find('.error').removeClass('error');

        const emailInput = form.find('input[name=user_login]');
        let email = emailInput.val();

        if (!email || !validateEmail(email)) return showError(emailInput, 'No or wrong e-mail address entered.');

        let data = {
            action: 'woocommerce_ajax_reset_password',
            email, nonce
        };
        // Append Turnstile token when the widget is present in the form
        let turnstileTokenReset = form.find('input[name="cf-turnstile-response"]').val();
        if (turnstileTokenReset) {
            data['cf-turnstile-response'] = turnstileTokenReset;
        }
        if (modal_content && modal_content.length) showModalLoader(modal_content);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            success: function (response) {
                if (modal_content && modal_content.length) hideModalLoader(modal_content);
                if (response.success) {
                    if (modals.resetPassword) modals.resetPassword.hide();
                    if (modals.resetPasswordSuccess) modals.resetPasswordSuccess.show();
                    $('#js-message').text(response.messages.success_message);
                    setTimeout(function () { location.reload(); }, 3000);
                } else {
                    showError(emailInput, response.messages.password_reset_error_message);
                }
            },
            error: function() {
                if (modal_content && modal_content.length) hideModalLoader(modal_content);
                showError(emailInput, 'An error occurred. Please try again later.');
            }
        });
    });

    // Facebook login handler
    $(document).on('click', '#facebook-login', function (e) {
        e.preventDefault();
        fbLogin();
    });

    function fbLogin() {
        if (typeof wc_social_login_params === 'undefined' || !wc_social_login_params.facebook_app_id) {
            console.error('Facebook App ID not configured');
            showGeneralError('#modal-login', 'Facebook login is not properly configured. Please contact support.');
            return;
        }
        FB.init({
            appId      : wc_social_login_params.facebook_app_id,
            cookie     : true,
            xfbml      : true,
            version    : 'v15.0'
        });
        FB.login(function(response) {
            if (response.status !== 'connected') {
                console.error('Facebook login failed');
                showGeneralError('#modal-login', 'Facebook login was cancelled or failed. Please try again.');
                return;
            }
            FB.api('/me?fields=first_name,last_name,email,id,birthday', function(response) {
                let email = response.email || '';
                $.ajax({
                    type: 'post',
                    url: wc_add_to_cart_params.ajax_url,
                    data: {
                        action: 'register_social_user',
                        social_net: 'facebook',
                        first_name: response.first_name,
                        last_name:  response.last_name,
                        birthday: response.birthday,
                        id: response.id,
                        email: email,
                    },
                    success: function (response) {
                        if (response.success && response.signon) {
                            if (response.messages && response.messages.success_message) {
                                showGeneralError('#modal-login', '<div style="background:#d4edda; border-color:#c3e6cb; color:#155724;">' + response.messages.success_message + '</div>');
                            }
                            setTimeout(function() { location.reload(); }, 1500);
                        } else {
                            // Display only unique error messages
                            let errorMessages = [];
                            let seenMessages = new Set();
                            
                            for (const [error, message] of Object.entries(response.messages)) {
                                // Skip dev_message and only add unique messages
                                if (error !== 'dev_message' && !seenMessages.has(message)) {
                                    errorMessages.push(message);
                                    seenMessages.add(message);
                                }
                            }
                            
                            if (errorMessages.length > 0) {
                                showGeneralError('#modal-login', errorMessages.join('<br>'));
                            }
                        }
                    },
                    error: function() {
                        showGeneralError('#modal-login', 'An error occurred during Facebook sign-in. Please try again later.');
                    }
                });
            });
        }, {
            scope: 'public_profile, email',
            authType: 'rerequest'
        });
    }

    // Google login handler
    function handleCredentialResponse(response) {
        const responsePayload = decodeJwtResponse(response.credential);
        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: {
                action: 'register_social_user',
                social_net: 'google',
                first_name: responsePayload.given_name,
                last_name:  responsePayload.family_name,
                id: responsePayload.sub,
                email: responsePayload.email,
            },
            success: function (response) {
                if (response.success && response.signon) {
                    if (response.messages && response.messages.success_message) {
                        showGeneralError('#modal-login', '<div style="background:#d4edda; border-color:#c3e6cb; color:#155724;">' + response.messages.success_message + '</div>');
                    }
                    setTimeout(function() { location.reload(); }, 1500);
                } else {
                    // Display only unique error messages
                    let errorMessages = [];
                    let seenMessages = new Set();
                    
                    for (const [error, message] of Object.entries(response.messages)) {
                        // Skip dev_message and only add unique messages
                        if (error !== 'dev_message' && !seenMessages.has(message)) {
                            errorMessages.push(message);
                            seenMessages.add(message);
                        }
                    }
                    
                    if (errorMessages.length > 0) {
                        showGeneralError('#modal-login', errorMessages.join('<br>'));
                    }
                }
            },
            error: function() {
                showGeneralError('#modal-login', 'An error occurred during Google sign-in. Please try again later.');
            }
        });
    }
    if (typeof window.handleCredentialResponse === 'undefined') {
        window.handleCredentialResponse = handleCredentialResponse;
    }
});